import { setItem } from "~/es6/localstorage";
import { CONFIG } from "~/config";
import Scene from "~/scene";
import { store } from "~/state/store";
import { setMapset, setCoordinates } from "~/state/map/state";
import { IMapState } from "./state/map/interfaces";

const DEF_OPTIONS = {
	className: "cesko",
	mapset: "zakladni",
	storageName: "april",
	czArea: false,
	zoomRange: null,
};
let options = {
	...DEF_OPTIONS,
};
let prevMapState: IMapState = null;

function getConfig(egg: IMapState["egg"]) {
	switch (egg) {
		case "none":
			return {};

		case "textova":
			return {
				mapset: "textova",
				storageName: "april2017",
			};

		case "ceskoza100":
			return {
				mapset: "ceskoza100",
				storageName: "april2018",
				czArea: true,
				zoomRange: [8, 10],
			};

		default:
			return {};
	}
}

export function setEggVariant(egg: IMapState["egg"]) {
	Object.assign(options, getConfig(egg));

	const mapState = store.getState().map;
	const { longitude, latitude, zoom } = mapState;

	prevMapState = { ...mapState };

	if (prevMapState && prevMapState.mapset === options.mapset) {
		prevMapState = null;
	} else {
		store.dispatch(setMapset({ mapset: options.mapset }));
	}

	let zoomRange = [8, 10];

	if (options.zoomRange && Array.isArray(options.zoomRange) && options.zoomRange.length === 2) {
		zoomRange = options.zoomRange;
	}

	if (options.czArea) {
		const area = Mapy.getComponent("statearea").lastCheck();

		if (area.cs && area.cs.find) {
			store.dispatch(setCoordinates({
				longitude,
				latitude,
				zoom: Math.max(zoomRange[0], Math.min(zoomRange[1], zoom)),
				animate: true,
			}));
		} else {
			store.dispatch(setCoordinates({
				longitude: CONFIG.initialMap.lon,
				latitude: CONFIG.initialMap.lat,
				zoom: zoomRange[0],
				animate: true,
			}));
		}
	}

	if (options.zoomRange) {
		Scene.setZoomRange(zoomRange[0], zoomRange[1]);
	}
}

export function removeEgg() {
	setItem(options.storageName, "1");
	store.dispatch(setMapset(prevMapState || { mapset: "zakladni" }));
	options = {
		...DEF_OPTIONS,
	};
	Mapy.getComponent("history").save();
}
